import React from 'react'

const RutaNoValida = () => {
  return (
    <div className='rutaNoValida'>
        <img src='https://cdn-icons-png.flaticon.com/512/63/63422.png' alt='RutaNoValida'></img>
        <h1>¡Lo sentimos esta ruta no es valida!</h1></div>
  )
}

export default RutaNoValida